export const GET_ALL_EMAILS_START = 'GET_ALL_EMAILS_START';
export const GET_ALL_EMAILS_SUCCESS = 'GET_ALL_EMAILS_SUCCESS';
export const GET_ALL_EMAILS_ERROR = 'GET_ALL_EMAILS_ERROR';
